<div class="content">
    <div class="copyright">Copyright &copy; {{ date | date:'yyyy' }} Chevron Corporation</div>
    <div class="logo">
        <div class="hallmark"></div>
    </div>
    <div class="copyright-mobile">Copyright &copy; {{ date | date:'yyyy' }}<br/>Chevron Corporation</div>
    <div class="access">Restricted Access -Internal Use Only | Version: {{ version }}</div>
</div>

